import { mergeJson } from "../../utils/utils";
import {userInfoAfter} from "../../utils/facebook"
const mutations = {
  setUser(state, data) {
    state.user = mergeJson(state.user, data, true);
    // 获取用户信息
    // 加载facebook埋点
    userInfoAfter()
  },
  setParams(state, data) {
    !state.user && (state.user = {});
    data.token && (state.user.token = data.token);
    data.secretKey && (state.user.secretKey = data.secretKey);
    data.country && (state.user.country = data.country);
    data.balance && (state.user.balance = data.balance);
    data.platform && (state.platform = data.platform);
    data.amount != 0 && data.amount && (state.depositMoney = data.amount);
    data.type && (state.type = data.type);
    // data.isActivity && data.amount && (state.isActivity = true);
    state.uriParams = data;
  },
  setDepositMoney(state, value) {
    state.depositMoney = value;
  },
  SET_LIMIT (state, limit) {
    state.min = limit.min
    state.max = limit.max
  },
  SET_CARD_LIST: (state, cardList) => {
    state.cardList = cardList;
  },
  SET_TAB_LIST: (state, tabList) => {
    state.tabList = tabList;
  },
  SET_AMOUNT_LIST: (state, amountList) => {
    state.amountList = amountList;
  },
  SET_BACKEVENT_STATUS: (state, status) => {
    state.backEeventStatus = status;
  },
  setDepositGiftStatus(state, status) {
    state.depositGiftStatus = status;
  },
  setDepositGiftRate(state, rate) {
    state.depositGiftRate = rate;
  },
  setDepositGiftList(state, list) {
    state.depositGiftList = list;
  },
  SET_DEPOSIT_DATA (state, data) {
    state.depositResult = data
  },
  SET_WITHDRAW_DATA (state, data) {
    state.withdrawResult = data
  },
  setFirstBonusObj(state, data) {
    state.firstBonus = data;
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/actions/mutations.js